<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <form @submit.prevent="submit">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ action }} CAM Assignment</p>
        </header>
        <section class="modal-card-body country-assignment">
          <b-field label="Country">
            <b-select
              placeholder="Select a Country"
              :disabled="isView || isEdit"
              v-model="formData.country_id"
              expanded
              @input="updateStream"
              required
            >
              <option
                v-for="option in countries"
                :value="option.id"
                :key="option.id"
              >
                {{ option.name }}
              </option>
            </b-select>
          </b-field>
          <b-field label="Stream">
            <b-select
              placeholder="Select a Stream"
              v-model="formData.stream_id"
              @input="updateCustomers"
              :disabled="isView || isEdit"
              expanded
              required
            >
              <option
                v-for="option in containers"
                :value="option.id"
                :key="option.id"
              >
                {{ option.name }}
              </option>
            </b-select>
          </b-field>
          <b-field label="CAM User" required>
            <b-select
              placeholder="Select a Customer Account Manager"
              v-model="formData.account_manager_id"
              expanded
              required
              :disabled="isView"
            >
              <option
                v-for="option in usersCAM"
                :value="option.id"
                :key="option.id"
                :disabled="option.is_active == false"
                :hidden="option.is_active == false"
              >
                {{ option.name }}
              </option>
            </b-select>
          </b-field>
          <b-field label="Customer Scope" required>
            <b-select
              :disabled="isView"
              placeholder="Select Customer Scope"
              v-model="formData.customer_selection_type"
              expanded
              required
            >
              <option
                v-for="option in customerScope"
                :value="option"
                :key="option"
              >
                {{ option }}
              </option>
            </b-select>
          </b-field>
          <b-field
            label="Excluded Customers"
            v-if="this.formData.customer_selection_type == 'Excluded Customers'"
          >
            <multiselect
              :disabled="isView"
              ref="multiselect"
              v-model="excluded_customer_id"
              :options="filteredTags"
              placeholder="Select except customers"
              label="name"
              track-by="name"
              :searchable="true"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              :hide-selected="true"
              :show-labels="false"
              data-cy="filter-customers"
              openDirection="below"
              required
            >
              <span
                class="checkbox-label"
                slot="option"
                slot-scope="scope"
                :class="{ 'background-inactive': !scope.option.active }"
                :title="scope.option.name"
              >
                {{ scope.option.name }}
              </span>
            </multiselect>
          </b-field>
          <b-field
            label="Included Customers"
            v-if="this.formData.customer_selection_type == 'Included Customers'"
          >
            <multiselect
              :disabled="isView"
              ref="multiselect"
              v-model="included_customer_id"
              :options="filteredTags"
              placeholder="Select included customers"
              label="name"
              track-by="name"
              :searchable="true"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              :hide-selected="true"
              :show-labels="false"
              data-cy="filter-customers"
              openDirection="below"
              required
            >
              <span
                class="checkbox-label"
                slot="option"
                slot-scope="scope"
                :class="{ 'background-inactive': !scope.option.active }"
                :title="scope.option.name"
              >
                {{ scope.option.name }}
              </span>
            </multiselect>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <b-button
            class="button is-primary"
            slot="right"
            native-type="submit"
            type="is-primary"
            v-if="action != 'View'"
          >
            {{ action }}
          </b-button>
          <b-button
            class="button is-normal"
            slot="right"
            type="button"
            @click="cancel"
          >
            Cancel
          </b-button>
        </footer>
      </div>
    </form>
  </b-modal>
</template>

<script>
import { UserGroup } from "../../services/UserGroups";
import Multiselect from "vue-multiselect";
import CustomerUpdatesDataService from "../../services/CustomerUpdatesDataService";
// @group Reporting Tracker
export default {
  name: "CountryAssignment",
  components: { Multiselect },
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    customers: [],
    users: [],
    containers: [],
    countries: [],
    editData: {
      type: Object,
      default: () => {
        return {
          country_id: null,
          stream_id: null,
          account_manager_id: null,
          customer_selection_type: null,
          excluded_customer_id: [],
          included_customer_id: []
        };
      }
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isView: {
      type: Boolean,
      default: false
    },
    action: {
      type: String,
      default: "Add"
    }
  },
  data() {
    return {
      usersCAM: [],
      formData: [],
      scopes: [],
      included_customer_id: [],
      excluded_customer_id: [],
      filteredTags: [],
      isModalActive: false,
      selectedCAMUser: null,
      selectedCutomerScope: null,
      selectedStream: null,
      selectedCountry: null,
      selectedCAM: null,
      customerScope: [
        "All Customers",
        "Included Customers",
        "Excluded Customers"
      ],
      customerUpdatesDataService: new CustomerUpdatesDataService()
    };
  },
  mounted() {
    this.fetchScopes();
    //this.checkExternalPermission();
  },
  watch: {
    editData(newValue) {
      this.formData = newValue;
      this.updateCustomers();
      if (newValue.customer_excluded) {
        this.excluded_customer_id = this.filteredTags.filter(item =>
          newValue.customer_excluded.includes(item.id)
        );
      } else {
        this.excluded_customer_id = [];
      }
      if (newValue.customer_included) {
        this.included_customer_id = this.filteredTags.filter(item =>
          newValue.customer_included.includes(item.id)
        );
      } else {
        this.included_customer_id = [];
      }
    },
    users(newValue) {
      this.fetchUsers(newValue);
    },
    customers() {
      this.updateCustomers();
    },
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
    }
  },
  methods: {
    fetchScopes() {
      this.customerUpdatesDataService.getCustomerScopes().subscribe(
        response => {
          this.scopes = response;
        },
        e => {
          console.log(e);
        }
      );
    },
    updateStream() {
      this.formData.stream_id = null;
    },
    updateCustomers() {
      const selCustomers = this.scopes.filter(
        scope =>
          this.formData.country_id == scope.country &&
          this.formData.stream_id == scope.stream
      );
      const selectedIds = selCustomers.map(a => a.customer);
      this.filteredTags = this.customers.filter(
        item => selectedIds.includes(item.id) && item.parent_customer == null
      );
    },
    cancel() {
      this.isModalActive = false;
      this.$emit("cancle");
    },

    filterUsers(users, role) {
      const newUsers = [];
      for (const user of users) {
        const epradmin = user.groups.filter(e => e.name === role);
        if (epradmin.length > 0) {
          newUsers.push(user);
        }
      }
      return newUsers;
    },
    fetchUsers(newValue) {
      //  filter users based onn groups
      this.usersCAM = this.filterUsers(
        newValue,
        UserGroup.CUSTOMER_ACCOUNT_MANAGER
      );
    },

    submit() {
      if (this.formData.customer_selection_type == "Included Customers") {
        this.formData["included_customer_id"] = this.included_customer_id.map(
          a => a.id
        );
        if (this.included_customer_id.length > 0) {
          this.$emit("submit", this.formData);
          this.formData = [];
          this.included_customer_id = [];
          this.excluded_customer_id = [];
        } else {
          this.$buefy.dialog.alert({
            title: "Error",
            message: "Please select at least one included customer",
            type: "is-danger",
            ariaRole: "alertdialog",
            ariaModal: true
          });
        }
      } else if (
        this.formData.customer_selection_type == "Excluded Customers"
      ) {
        this.formData["excluded_customer_id"] = this.excluded_customer_id.map(
          a => a.id
        );
        if (this.excluded_customer_id.length > 0) {
          this.$emit("submit", this.formData);
          this.formData = [];
          this.included_customer_id = [];
          this.excluded_customer_id = [];
        } else {
          this.$buefy.dialog.alert({
            title: "Error",
            message: "Please select at least one excluded customer",
            type: "is-danger",
            ariaRole: "alertdialog",
            ariaModal: true
          });
        }
      } else {
        this.$emit("submit", this.formData);
        this.formData = [];
        this.included_customer_id = [];
        this.excluded_customer_id = [];
      }
    }
  }
};
</script>
